package one.healthium.profile.ui.weight

import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.TimeZone
import kotlinx.datetime.format
import kotlinx.datetime.format.char
import kotlinx.datetime.toLocalDateTime
import loco.GENERAL_TODAY
import one.healthium.base.utils.localizedMonthNames
import one.healthium.domain.common.isToday
import one.healthium.domain.user.models.WeightLogModel
import one.healthium.loco.LString
import one.healthium.loco.asLString
import androidx.compose.runtime.Immutable
import kotlin.time.Instant

@Immutable
data class WeightHistoryUiModel(
    val value: Float,
    val date: Instant,
) {
    val id = date.toString() + value

    val dateRelativeShort: LString = date.formatRelative()
    val dateFull: String = date.toLocalDateTime(TimeZone.currentSystemDefault()).format(dateFormatFull)

    companion object {
        fun fromModel(weightHistory: WeightLogModel) = WeightHistoryUiModel(
            value = weightHistory.value,
            date = weightHistory.date,
        )
    }
}

fun Instant.formatRelative(): LString =
    if (isToday()) loco.Res.string.GENERAL_TODAY.asLString()
    else toLocalDateTime(TimeZone.currentSystemDefault()).format(dateFormat).asLString()

private val dateFormat = LocalDateTime.Format {
    monthName(localizedMonthNames(abbreviated = true))
    char(' ')
    day()
}

private val dateFormatFull = LocalDateTime.Format {
    monthName(localizedMonthNames())
    char(' ')
    day()
}
